import React from "react";
import {withTranslation} from "react-i18next";
import i18next from "../../resource/i18n";
import VenueInquiryComp from './VenueInquiryComp';

class VenueComp  extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectTap: "central",
		};
	}

	componentDidMount() {
	}
	
	changeTap = type => () => {
		this.setState({selectTap: type});
	}

	render() {
		const {t} = this.props;
		let rLink = "https://docs.google.com/forms/d/e/1FAIpQLSdytO-oLRpFeMrLTQ_XGfo3Ea1faOzXRaV25_cOZE1o0E-CEQ/viewform?usp=sf_link"
		if (i18next.language === "en" ) {
			rLink = "https://docs.google.com/forms/d/e/1FAIpQLSeMnEp8ZXUSvK7EVHHj5pAc4Q3rRoZ18U09tbFc0tDvKTwfvw/viewform"
		}
		return (
			 <div className="content-wrap sub-content">
                <div className="visual-slide-wrap">
                    <div className="visual-slide-list">
                        <div className="slide">
                            <div className="img">
                                <img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_main.png" alt="VENUE RENTAL"/>
                            </div>
                        </div>          
                    </div>
                    
                    <div className="visual-slide-text">
                        <div className="inner">
                            <div className="con">
                                <div className="text-wrap color1">
                                    <p className="s-text typo1">{t('Venue_visual_title')}</p>
									<p className="m-text">{t('Venue_visual_desc')}</p>
									<p className="m-text">{t('Venue_visual2_desc')}</p>
                                </div>
                            </div>  
                        </div>  
                    </div>
                </div>
				<div className="detail-con-wrap">
					<div className="inner">
						<div className="list list-type6">
							<div className="tab-wrap">
								<ul className="venue-tab-menu">
									<li><button onClick={this.changeTap("central")} className={((this.state.selectTap === "central") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Venue_tab_3')}</button></li>
									<li><button onClick={this.changeTap("lounge")} className={((this.state.selectTap === "lounge") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Venue_tab_1')}</button></li>
									<li><button onClick={this.changeTap("team-room")} className={((this.state.selectTap === "team-room") ? "selected" : "")} style={{ cursor: "pointer" }}>{t('Venue_tab_2')}</button></li>
								</ul>
								<ul className="venue-tab-menu">
									<li><button onClick={this.changeTap("space-zero")} className={((this.state.selectTap === "space-zero") ? "selected" : "")} style={{ cursor: "pointer" }}>{t('Venue_tab_4')}</button></li>
									<li><button onClick={this.changeTap("space-cup")} className={((this.state.selectTap === "space-cup") ? "selected" : "")} style={{ cursor: "pointer" }}>{t('Venue_tab_5')}</button></li>
									<li><button onClick={this.changeTap("central-garden")} className={((this.state.selectTap === "central-garden") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Venue_tab_6')}</button></li>
									<li><button onClick={this.changeTap("terrace")} className={((this.state.selectTap === "terrace") ? "selected" : "")} style={{cursor: "pointer"}}>{t('Venue_tab_7')}</button></li>
								</ul>
								<div className="tab-con-wrap">
									{/* 1. 센트럴 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "central") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_central_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_central_detail_desc1')}<br />
												{t('Venue_central_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_central_detail_desc3')} / {t('Venue_central_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_central_1.png" alt="CENTRAL 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_central_2.png" alt="CENTRAL 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_central_3.png" alt="CENTRAL 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_central_4.png" alt="CENTRAL 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 2. 라운지 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "lounge") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_lounge_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_lounge_detail_desc1')}<br />
												{t('Venue_lounge_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_lounge_detail_desc3')} / {t('Venue_lounge_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_lounge_1.png" alt="LOUNGE 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_lounge_2.png" alt="LOUNGE 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_lounge_3.png" alt="LOUNGE 3" style={{ width: "100%", display: "block" }}/>
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_lounge_4.png" alt="LOUNGE 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 3. 팀룸 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "team-room") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_teamroom_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_teamroom_detail_desc1')}<br />
												{t('Venue_teamroom_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_teamroom_detail_desc3')} / {t('Venue_teamroom_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_teamroom_1.png" alt="TEAM ROOM 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_teamroom_2.png" alt="TEAM ROOM 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_teamroom_3.png" alt="TEAM ROOM 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_teamroom_4.png" alt="TEAM ROOM 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 4. 스페이스 제로 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "space-zero") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_spacezero_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_spacezero_detail_desc1')}<br />
												{t('Venue_spacezero_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_spacezero_detail_desc3')} / {t('Venue_spacezero_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacezero_1.png" alt="SPACEZERO 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacezero_2.png" alt="SPACEZERO 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacezero_3.png" alt="SPACEZERO 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacezero_4.png" alt="SPACEZERO 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 5. 스페이스 컵 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "space-cup") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_spacecup_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_spacecup_detail_desc1')}<br />
												{t('Venue_spacecup_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_spacecup_detail_desc3')} / {t('Venue_spacecup_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacecup_1.png" alt="SPACECUP 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacecup_2.png" alt="SPACECUP 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacecup_3.png" alt="SPACECUP 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_spacecup_4.png" alt="SPACECUP 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 6. 야외가든 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "central-garden") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_centralgarden_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_centralgarden_detail_desc1')}<br />
												{t('Venue_centralgarden_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_centralgarden_detail_desc3')} / {t('Venue_centralgarden_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_ground_1.png" alt="GROUND 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_ground_2.png" alt="GROUND 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_ground_3.png" alt="GROUND 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_ground_4.png" alt="GROUND 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* 7. 야외 테라스 */}
									<div className="tab-con" style={{display: (this.state.selectTap === "terrace") ? "block" : "none"}}>										
										<div className="list-con">
											<p className="lg-ttl2">
												{t('Venue_terrace_detail_title')}<br />
											</p>
											<div className="txt2">
												{t('Venue_terrace_detail_desc1')}<br />
												{t('Venue_terrace_detail_desc2')}<br />
											</div>
											<div style={{borderTop: "1px solid #ccc", marginTop: "30px"}}>
											</div>
											<div className="txt3">
												<span className="txt">{t('Venue_terrace_detail_desc3')} / {t('Venue_terrace_detail_size')}</span>
											</div>
											<div style={{borderTop: "2px solid #000"}}>
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_terrace_1.png" alt="TERRACE 1" />
											</div>
										</div>
										<div className="list-con2">
											<div className="img">
												<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_terrace_2.png" alt="TERRACE 2" />
											</div>
										</div>
										<div className="list-con2">
											<div className="card-list" style={{ display: "flex", gap: "50px" }}>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_terrace_3.png" alt="TERRACE 3" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
												<div className="card" style={{ flex: "1" }}>
													<div className="card-inner">
														<img src="https://asset.981park.com/www/common/web/img/sub/groups/groups_rental_terrace_4.png" alt="TERRACE 4" style={{ width: "100%", display: "block" }} />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<VenueInquiryComp showBackBtn={false} />
							</div>
						</div>
					</div>
				</div>
			</div>					
			
		);
	}
}
export default withTranslation()(VenueComp);
